<template>
  <b-container fluid>
        <b-row> 
            <b-col>
                <form @submit.prevent="setOrgspace">
                    <div class="card p-3 m-lg-3 mb-2">
                        <div class="header-card">
                            <p class="card-title">Organization Details</p>
                        </div>
                        <div class="body-card">
                            <div class="field-division">
                                <span class="field-label">Organization Name</span>
                                <b-form-input
                                    :disabled="true"
                                    v-model="organization.name"
                                    placeholder=""
                                ></b-form-input>
                            </div>

                            <div class="field-division">
                                <span class="field-label">Organization Short Name</span>
                                <b-form-input
                                    :disabled="true"
                                    v-model="organization.shortname"
                                    placeholder=""
                                ></b-form-input>
                            </div>

                            <div class="field-division">
                                <span class="field-label">Organization Description</span>
                                <b-form-textarea
                                    rows="6"
                                    v-model="organization.description"
                                    placeholder=""
                                ></b-form-textarea>
                            </div>

                        </div>
                        

                        <div class="footer-edit text-right mt-3">
                            <b-button class="v-button p-lg-2" type="submit" variant="success">Update <b-icon-pencil-square></b-icon-pencil-square></b-button>
                        </div>

                    </div>

                    <div class="card p-3 m-lg-3 mb-2">
                        <div class="header-card">
                            <p class="card-title">Organization Users</p>
                        </div>
                        <div class="body-card">

                            <div class="field-division">
                                <span class="field-label">Current Users on Current Plan</span>
                                <b-form-tags
                                    input-id="tags-separators"
                                    v-model="organization.space_users"
                                    separator=","
                                    class="tag-input"
                                    placeholder="Enter new separated by Comma"
                                ></b-form-tags>
                                {{ organization.space_users.length }} Users are in this Testspace
                            </div>

                            <div class="field-division">
                                <span class="field-label">Space Solid Users</span>
                                <b-form-tags
                                    input-id="tags-separators"
                                    v-model="organization.solid_users"
                                    :disabled="true"
                                    separator=","
                                    class="tag-input"
                                    placeholder="Enter new separated by Comma"
                                ></b-form-tags>
                                {{ organization.solid_users.length }} Users are now Solid Users
                            </div>

                            <div class="field-division">
                                <span class="field-label">Alltime Users</span>
                                <b-form-tags
                                    input-id="tags-separators"
                                    v-model="organization.alltime_users"
                                    :disabled="true"
                                    separator=","
                                    placeholder="Enter new separated by Comma"
                                ></b-form-tags>
                                {{ organization.alltime_users.length }} Users are now Solid Users
                            </div>
                        </div>
                        

                        <div class="footer-edit text-right mt-3">
                            <b-button class="v-button p-lg-2" type="submit" variant="success">Update <b-icon-pencil-square></b-icon-pencil-square></b-button>
                        </div>
                    </div>

                    <div class="card p-3 m-lg-3 mb-2">
                        <div class="header-card">
                            <p class="card-title">Organization Plan</p>
                        </div>
                        <div class="body-card">
                            <div class="field-division">
                                <span class="field-label">Maximum Test Entry For Current Plan</span>
                                <b-form-spinbutton
                                    id="markper"
                                    v-model="organization.entries_available"
                                    min="1"
                                    max="50000"
                                    :disabled="true"
                                    step="1"
                                ></b-form-spinbutton>
                            </div>

                            <div class="field-division">
                                <span class="field-label">Available Test Credits</span><br>
                                <span class="info-span">*If the Current Plan is a Monthly Plan or Annual Plan, Test Credits is Paused until the Plan Period Expires</span>
                                <b-form-spinbutton
                                    id="markper"
                                    v-model="organization.credits_available"
                                    min="1"
                                    max="50000"
                                    :disabled="true"
                                    step="1"
                                ></b-form-spinbutton>
                            </div>

                            <div class="field-division">
                                <span class="field-label">Plan Type</span>
                                <b-form-input
                                    :disabled="true"
                                    v-model="organizationplan.current_plantype"
                                    placeholder=""
                                ></b-form-input>
                            </div>

                            <div class="field-division">
                                <span class="field-label">Current Plan</span>
                                <b-form-input
                                    :disabled="true"
                                    v-model="organizationplan.current_plan"
                                    placeholder=""
                                ></b-form-input>
                            </div>

                            <div class="field-division">
                                <span class="field-label">Current Plan status</span>
                                <b-form-input
                                    :disabled="true"
                                    v-model="organizationplan.active"
                                    placeholder=""
                                ></b-form-input>
                            </div>

                            <div class="field-division">
                                <span class="field-label">Current Plan Duration</span><br>
                                <b-form-spinbutton
                                    id="markper"
                                    v-model="organizationplan.duration"
                                    min="1"
                                    max="50000"
                                    :disabled="true"
                                    step="1"
                                ></b-form-spinbutton>
                            </div>

                            <div class="field-division">
                                <span class="field-label">Plan will expire on</span>
                                <b-form-input
                                    :disabled="true"
                                    v-model="organizationplan.expires"
                                    placeholder=""
                                ></b-form-input>
                            </div>

                        </div>
                        

                        <div class="footer-edit text-right mt-3">
                            <b-button class="v-button p-lg-2" :to="{ name : 'upgrade'}" variant="success">Upgrade Plan <b-icon-pencil-square></b-icon-pencil-square></b-button>
                        </div>

                    </div>

                    <div class="card p-3 m-lg-3 mb-2">
                        <div class="header-card">
                            <p class="card-title">Organization Testspaces</p>
                        </div>
                        <div class="body-card">

                        </div>
                        

                        <div class="footer-edit text-right mt-3">
                            <b-button class="v-button p-lg-2" :to="{ name : 'upgrade'}" variant="success">Upgrade Plan <b-icon-pencil-square></b-icon-pencil-square></b-button>
                        </div>

                    </div>
                </form>
            </b-col>
        </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import store from "@/store"

export default {
    data(){
        return {
            organization : this.getForm(),
        }
    },

    created(){
        // console.log(this.retrievedOrganization)
        this.organization = {
            name : this.retrievedOrganization.organization_name,
            shortname : this.retrievedOrganization.organization_shortname,
            description : this.retrievedOrganization.organization_description,
            test_spaces : this.retrievedOrganization.test_spaces,
            space_users : JSON.parse(this.retrievedOrganization.space_users),
            solid_users : JSON.parse(this.retrievedOrganization.solid_users),
            alltime_users : JSON.parse(this.retrievedOrganization.alltime_users),
            entries_available : this.retrievedOrganization.entries_available,
            credits_available : this.retrievedOrganization.credits_available,
            trackid : this.retrievedOrganization.track_id,

        }
    },

    beforeRouteEnter (to, from, next) {
        store.dispatch("admin/fetchOrganizationplan");
        next()
    },

    methods : {
        ...mapActions("admin", ['fetchOrganization', 'fetchOrganizationplan', 'updateOrganization']),
        getForm(){
            return {
                name : "",
                shortname : "",
                description : "",
                test_spaces : "",
                space_users : [],
                solid_users : [],
                alltime_users : [],
                credits_available : 0,
                entries_available : 0,
                trackid : ""
            }
        },
        setOrgspace(){
            return this.updateOrganization(this.organization).then(() => {
                // console.log(response.data)
            })
        }
    },

    computed : {
        ...mapState({
            retrievedOrganization: (state) => state.admin.organization[0],
            organizationplan : state => state.admin.organizationplan
        })
    },

}
</script>

<style>
.card {
  /* min-height: 70vh; */
  background-color: rgb(242, 242, 242);
  border-radius: 20px 20px;
}
.card-title {
  font-size: 1.5rem;
  font-weight: bold;
}
.field-division{
    margin-top:7px;
}
.tag-input{
    overflow: auto;
    scrollbar-width: thin;
    max-height: 400px;
}
.v-button{
  border-radius : 10px 10px;
  width: 10rem;
  /* height: 3rem; */
  background-color : #00984a;
  font-weight : bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border : 0px;
  font-size: 18px;
}
.v-button:hover{
    background-color: white;
    color: #00984a;
    border : 1px solid #00984a; 
}
.footer-edit{
    width: 100%;
}
.field-label{
    font-size:1.2rem;
    font-weight: bold;
}

@media (max-width: 999px) {
    .v-button{
        width:inherit;
        /* height: 2.5rem; */
        font-size: 0.8rem;
    }
    .s-header{
        font-size: 16px;
    }
}
</style>